<template>
  <div class="password profile-settings">
    <h3>个人设置</h3>

    <el-card shadow="never" class="avatar-card">
      <div slot="header" class="card-header">头像</div>
      <div class="avatar-editor">
        <user-avatar
          :name="name"
          :username="username"
          :avatar="avatarPreview || avatar"
          :user-id="username"
          size="lg"
          class="preview-avatar"
        />
        <div class="avatar-actions">
          <p class="tip">支持 jpg / png / gif / webp，不超过 2MB。未设置时显示姓名后两字彩色头像。也可在系统主页点击头像直接更换。</p>
          <div class="btn-row">
            <el-upload
              action="#"
              :show-file-list="false"
              :auto-upload="false"
              accept="image/jpeg,image/png,image/gif,image/webp,.jpg,.jpeg,.png,.gif,.webp"
              :on-change="onAvatarChange"
            >
              <el-button type="primary" size="small" :loading="avatarUploading" icon="el-icon-upload2">
                上传头像
              </el-button>
            </el-upload>
            <el-button
              size="small"
              :disabled="!avatar && !avatarPreview"
              :loading="avatarRemoving"
              @click="onRemoveAvatar"
            >
              恢复默认
            </el-button>
          </div>
        </div>
      </div>
    </el-card>

    <el-card shadow="never" class="pwd-card">
      <div slot="header" class="card-header">修改密码</div>
      <el-form
        :model="uploadForm"
        status-icon
        :rules="rules"
        ref="uploadForm"
        label-width="100px"
        class="demo-uploadForm"
      >
        <el-form-item label="旧密码" prop="oldPass">
          <el-input
            type="password"
            v-model="uploadForm.oldPass"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPass">
          <el-input
            type="password"
            v-model="uploadForm.newPass"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="checkPass">
          <el-input
            type="password"
            v-model="uploadForm.checkPass"
            autocomplete="off"
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="submitForm('uploadForm')"
            >提交</el-button
          >
          <el-button @click="resetForm('uploadForm')">清空</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { updatePass, uploadAvatar, removeAvatar } from "../api";
import { mapGetters } from "vuex";
import UserAvatar from "../components/UserAvatar.vue";

export default {
  name: "Password",
  components: { UserAvatar },
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入新密码"));
      } else {
        if (this.uploadForm.checkPass !== "") {
          this.$refs.uploadForm.validateField("checkPass");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.uploadForm.newPass) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      avatarPreview: "",
      avatarUploading: false,
      avatarRemoving: false,
      uploadForm: {
        oldPass: "",
        newPass: "",
        checkPass: "",
      },
      rules: {
        oldPass: { required: true, message: "请输入旧密码", trigger: "blur" },
        newPass: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          { validator: validatePass, trigger: "blur" },
          {
            pattern: new RegExp("^[a-zA-Z0-9_]{6,20}$"),
            message: "密码长度在6-20个字符，由数字和字母组成",
          },
        ],
        checkPass: [
          { required: true, message: "请再次输入密码", trigger: "blur" },
          { validator: validatePass2, trigger: "blur" },
        ],
      },
    };
  },
  computed: {
    ...mapGetters(["name", "username", "avatar"]),
  },
  methods: {
    onAvatarChange(file) {
      const raw = file && file.raw;
      if (!raw) return;
      const okType = /image\/(jpeg|png|gif|webp)/i.test(raw.type)
        || /\.(jpe?g|png|gif|webp)$/i.test(raw.name || "");
      if (!okType) {
        this.$message.error("仅支持 jpg / png / gif / webp");
        return;
      }
      if (raw.size > 2 * 1024 * 1024) {
        this.$message.error("头像大小不能超过 2MB");
        return;
      }
      this.avatarPreview = URL.createObjectURL(raw);
      const fd = new FormData();
      fd.append("file", raw);
      this.avatarUploading = true;
      uploadAvatar(fd)
        .then((res) => {
          if (res.code === 0) {
            this.$store.commit("setAvatar", res.data || "");
            this.avatarPreview = "";
            this.$message.success(res.msg || "头像已更新");
          } else {
            this.avatarPreview = "";
            this.$message.error(res.msg || "上传失败");
          }
        })
        .catch(() => {
          this.avatarPreview = "";
          this.$message.error("上传失败");
        })
        .finally(() => {
          this.avatarUploading = false;
        });
    },
    onRemoveAvatar() {
      this.avatarRemoving = true;
      removeAvatar()
        .then((res) => {
          if (res.code === 0) {
            this.$store.commit("setAvatar", "");
            this.avatarPreview = "";
            this.$message.success(res.msg || "已恢复默认头像");
          } else {
            this.$message.error(res.msg || "操作失败");
          }
        })
        .catch(() => {
          this.$message.error("操作失败");
        })
        .finally(() => {
          this.avatarRemoving = false;
        });
    },
    submitForm(formName) {
    let _this = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          //前端校验通过后，进行登陆操作
          let params = new URLSearchParams();
          params.append("old-pass", this.uploadForm.oldPass);
          params.append("new-pass", this.uploadForm.newPass);
          params.append("new-pass-v", this.uploadForm.checkPass);
          updatePass(params)
            .then((res) => {
              //closeDebug console.log("-----------提交密码修改---------------");
              //closeDebug console.log(res);
              if (res.code === 0) {
                _this.$message({
                  message: res.msg,
                  type: "success",
                });
              } else {
                _this.$message({
                  message: res.msg,
                  type: 'error'
                });
              }
            })
            .catch((failResponse) => {});
        } else {
          //closeDebug console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>

<style scoped>
.profile-settings {
  max-width: 640px;
  padding: 8px 4px 24px;
}
.profile-settings h3 {
  margin: 0 0 16px;
  font-size: 18px;
  color: #303133;
}
.avatar-card,
.pwd-card {
  margin-bottom: 16px;
}
.card-header {
  font-weight: 600;
  color: #303133;
}
.avatar-editor {
  display: flex;
  align-items: flex-start;
  gap: 20px;
}
.preview-avatar {
  width: 72px !important;
  height: 72px !important;
  font-size: 28px !important;
}
.avatar-actions {
  flex: 1;
  min-width: 0;
}
.tip {
  margin: 0 0 12px;
  font-size: 13px;
  color: #909399;
  line-height: 1.5;
}
.btn-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
}
</style>
